import {Box, Grid, Tab, Tabs, Button, Autocomplete, TextField} from "@mui/material"
import React, {useState, useEffect} from "react"
import LayoutPage from "src/components/page-layout/layout-page"
import AlertMessage from "src/components/alert-message"
import Balancos from "./demo_financeiras"
import EmpresaPage from "./empresa_page"
// import OutroDocumentos from "./outros_documentos"
import GrupoEconomico from "./grupo_economico"
import Emissoes from "./emissoes"
import DatalakeService from "src/services/datalake-service"
import ModalDialogPage from "src/components/modal-dialog"
import {DataGrid} from "@mui/x-data-grid"
import {TokenService} from "../../services/token-service"
import MarketToMarket from "./tab/market-to-market/market-to-market-tab"
import { formatCpfCnpj } from "src/utils/format-cpf-cnpj"


const EmpresasPage = () => {
    const [data, setData] = useState([])
    const calcService = new DatalakeService()
    const tokenService = new TokenService()
    const [selectedTab, setSelectedTab] = useState(0)
    const [loading, setLoading] = useState(false)
    const [selectedOption, setSelectedOption] = useState(null)
    const [alertMessageState, setAlertMessageState] = React.useState({
        open: false,
        message: "",
        type: ""
    })
    const [isLoading, setIsLoading] = useState(false)
    const [modalCompleteList, setModalCompleteList] = useState(false)
    const [EmpresasList, setEmpresasList] = useState([])
    const [userAdmin, setUserAdmin] = useState(false)

    const loadData = () => {
        setIsLoading(true)
        calcService.loadList().then((response) => {
            const {body} = response
            const {results} = body

            const list = results
                .filter((obj) => obj.Setor !== "Consórcio")
                .map((obj, index) => {
                    const rawCPFCNPJ = obj.CPFCNPJ?.toString() || ""

                    const formattedCPFCNPJ = formatCpfCnpj(rawCPFCNPJ)

                    return {
                        ...obj,
                        id: index,

                        // mantém o valor original
                        CPFCNPJ: rawCPFCNPJ,

                        // valor formatado só para exibição
                        formattedCPFCNPJ,

                        // string exibida no autocomplete
                        displayString: `${obj.RazaoSocial} | ${formattedCPFCNPJ}`,
                    }
                })

            setEmpresasList(list)
            setData(list)
        })
            .catch((error) => {
                openAlert("Erro no carregamento de dados", "error")
                console.error("Erro ao buscar dados:", error)
                setData([])
            })
            .finally(() => setIsLoading(false))
    }

    useEffect(() => {
        loadData()
    }, [])

    useState(() => {
        const userIsAdmin = tokenService.verifyUserIsAdmin()
        setUserAdmin(userIsAdmin)
    }, [])

    const removeDiacritics = (str) =>
        str.normalize("NFD").replace(/[\u0300-\u036f]/g, '')

    const filterAutocompleteOptions = (options, inputValue) => {
        if (!inputValue || !Array.isArray(options)) return EmpresasList

        // Normaliza o input: remove acentos e mantém apenas letras, números, espaço, hífen, ponto, vírgula e pipe
        const sanitizedInput = removeDiacritics(inputValue.toLowerCase().trim())
            .replace(/[^a-zA-Z0-9\s\u002D.,|]/g, '') // hífen = \u002D

        return options.filter((option) => {
            const formattedCPFCNPJ = (option.formattedCPFCNPJ || '').toString().toLowerCase()
            const razaoSocial = (option.RazaoSocial || '').toString().toLowerCase()

            const formattedCNPJ = removeDiacritics(formattedCPFCNPJ).replace(/[^\d-]/g, '') // mantém números e hífen
            const displayString = removeDiacritics(`${razaoSocial} | ${formattedCPFCNPJ}`)

            return (
                displayString.includes(sanitizedInput) ||
                formattedCNPJ.includes(sanitizedInput)
            )
        })
    }

    const openAlert = (message, type) => {
        setAlertMessageState({
            ...alertMessageState,
            open: true,
            message: message,
            type: type
        })
    }

    const closeAlert = () => {
        setAlertMessageState({...alertMessageState, open: false})
    }

    const handleClickMostrarTodosTable = (data) => {
        const {row} = data

        setSelectedOption({
            ...row,
            displayString: `${row.RazaoSocial} - ${row.CPFCNPJ}`,
        })

        setModalCompleteList(false)
    }

    const tabList = [
        { label: "EMPRESA", component: <EmpresaPage loading={setLoading} alert={openAlert} empresa={selectedOption} /> },
        { label: "MARKET TO MARKET", component: <MarketToMarket loading={setLoading} alert={openAlert} empresa={selectedOption} />},
        ...(userAdmin ? [{ label: "BALANÇOS", component: <Balancos loading={setLoading} alert={openAlert} /> }] : []),
        { label: "EMISSÕES", component: <Emissoes loading={setLoading} alert={openAlert} empresa={selectedOption} /> },
        { label: "GRUPO ECONÔMICO", component: <GrupoEconomico loading={setLoading} alert={openAlert} empresa={selectedOption} onSelectEmpresa={handleClickMostrarTodosTable} /> },
        // { label: "OUTROS DOCUMENTOS", component: <OutroDocumentos loading={setLoading} empresa={selectedOption} alert={openAlert} /> }
    ]

    const renderContent = () => tabList[selectedTab]?.component || null

    return (
        <LayoutPage title="Empresas" loading={loading}>
            <AlertMessage open={alertMessageState.open} message={alertMessageState.message}
                          type={alertMessageState.type} close={closeAlert}/>
            <Grid direction={"row"} container alignItems="center" justifyContent="space-between" spacing={3}>
                <Grid item xs={6} md={8} sm={12}>
                    <Grid container direction={"row"} spacing={3} alignItems="center">
                        <Grid item xs={4} md={6} sm={6}>
                            <Autocomplete
                                options={data}
                                getOptionLabel={(option) => option.displayString || ''}
                                filterOptions={(options, {inputValue}) =>
                                    filterAutocompleteOptions(options, inputValue)
                                }
                                value={selectedOption}
                                onChange={(event, newValue) => setSelectedOption(newValue)}
                                loading={isLoading}
                                renderInput={(params) => (
                                    <TextField {...params} label="Razão Social ou CNPJ" variant="outlined"/>
                                )}
                                fullWidth
                                loadingText="Carregando opções..."
                            />
                        </Grid>
                        <Grid item xs={6} md={6} sm={6}>
                            <Button color={"primary"} variant={"contained"} onClick={() => setModalCompleteList(true)}>Consultar
                                Lista Completa

                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <br/>

            <Grid container direction={"row"} alignItems={"center"}>
                <Grid item xs={12} sm={12} md={12} xl={12} sx={{height: "100%"}}>
                    <Box
                        sx={{
                            height: "100vh",
                            display: "flex",
                            flexDirection: "column"
                        }}>
                        <Tabs value={selectedTab} onChange={(e, newValue) => setSelectedTab(newValue)}>
                            {tabList.map((tab, index) => (
                                <Tab key={index} label={tab.label} />
                            ))}
                        </Tabs>
                        <Box
                            sx={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                            }}>
                            <Grid
                                container
                                direction="row"
                                alignContent="flex-start"
                                justifyContent="flex-start"
                                spacing={0}
                                sx={{
                                    padding: 2,
                                    height: "100%", // altura de 100% da Box
                                }}>
                                <Grid item xs={12} sm={12} md={12} xl={12} sx={{height: "100%"}}>
                                    {renderContent()}
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Grid>
            </Grid>


            <ModalDialogPage open={modalCompleteList}
                             title="Lista de Empresas"
                             close={() => {
                                 setModalCompleteList(false)
                             }}>
                <>
                    <Grid container direction="column">
                        <Grid item xs={12} md={12} xl={12}>
                            <DataGrid
                                autoHeight
                                columns={[
                                    {field: 'CPFCNPJ', headerName: 'CPFCNPJ', width: 200},
                                    {field: 'CodigoCVM', headerName: 'Código CVM', width: 200},
                                    {field: 'Ticker', headerName: 'Ticker B3', width: 200},
                                    {field: 'RazaoSocial', headerName: 'Razão Social', width: 300},
                                    {field: 'NomeFantasia', headerName: 'Nome Fantasia', width: 300},
                                    {field: 'Setor', headerName: 'Setor', width: 300},
                                    {field: 'SubSetor', headerName: 'SubSetor', width: 300},
                                    {field: 'GrupoEconomico_Nome', headerName: 'Grupo Econômico', width: 300},

                                ]}
                                rows={EmpresasList}
                                onRowClick={handleClickMostrarTodosTable}
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 25,
                                        },
                                    },
                                }}
                                pageSizeOptions={[25, 50, 100]}
                            />
                        </Grid>
                    </Grid>
                </>
            </ModalDialogPage>
        </LayoutPage>
    )
}

export default EmpresasPage